module.exports = __webpack_public_path__ + "static/media/ExitModalDesktop.83946877.png";